'use strict';

var React = require('react');

var SvgCardReaderChipMajor = function SvgCardReaderChipMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 0a1.5 1.5 0 0 1 1.5 1.5v7.5h-3v-9h1.5zm-3.5 0h-5.5a1.5 1.5 0 0 0-1.5 1.5v7.5h7v-9zm-7.5 11a1.5 1.5 0 0 0-1.5 1.5v5.5h-1a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2h-1v-5.5a1.5 1.5 0 0 0-1.5-1.5h-13z"
  }));
};

exports.SvgCardReaderChipMajor = SvgCardReaderChipMajor;
